import { Helper } from "../util/helper.js";
import { BaseComponentProps, BaseDataSourceField, BaseField } from "./baseComponentProps.js";
import React from "react";

export class IsTimeTextBox extends React.Component<TimeTextBoxProps, any>{
    private _maskTextBoxRef: any;
    private _maskTextBox: kendo.ui.MaskedTextBox;
    private _value: any;
    private _disabled = true;

    componentWillUnmount() {
        this._maskTextBox.destroy();
    }

    handleChange = (e) => {
        var timeAsString = this.prepareTime(this._maskTextBox.value());
        this._maskTextBox.value(timeAsString);
        var model = this.toMinutesSinceMidnight(timeAsString);
        this._value = model;

        this.props.onChange(this.props.field, model, null);
        this.props.onChange({ model: this.props.field.modelForTimeString }, timeAsString, null);
    }

    componentDidMount() {
        this._disabled = this.props.disabled || false;
        this._value = Helper.dates.fromMinutesSinceMidnight(this.props.value);
        var that = this;
        let mask = "00:00";
        if (this._value && (this._value as string).length > 5) {
            mask = "000:00";
        }
        this._maskTextBox = $(this._maskTextBoxRef).kendoMaskedTextBox({
            mask: mask,
            value: this._value,
            change: that.handleChange
        }).data("kendoMaskedTextBox");

        this._maskTextBox.readonly(this._disabled);
        this._maskTextBox.wrapper.attr("data-readonly", this._disabled.toString());
    }

    componentDidUpdate(prevProps, prevState) {
        let minutes = Helper.dates.fromMinutesSinceMidnight(this.props.value);
        if (this._value !== minutes) {
            this._value = minutes;
            this._maskTextBox.value(this._value);
        }
        const isDisabled = this.props.disabled || false;
        if (this._disabled !== isDisabled) {
            this._disabled = isDisabled;
            this._maskTextBox.readonly(this._disabled);
            this._maskTextBox.wrapper.attr("data-readonly", this._disabled.toString());
        }
    }

    /// Macht aus einer "ungültigen" Uhrzeit eine gültige im Format "HH:mm"
    /// Wird z.B. "12" übergeben ist der Rückgabewert "12:00".
    /// Bei "4" ist der Rückgabewert "04:00".
    /// Bei "231" ist der Rückgabewert "23:10" usw.
    // Bei > 24:00 oder ungültigen Uhrzeiten wie 12:99 wird 00:00 zurückgeliefert
    prepareTime(timeString) {
        var time = timeString.replace(":", "").replace(/_/g, "");

        if (time.length == 0 || time.Length > 4)
            return time;

        if (time.length == 1 || (time[0] != "0" && time[0] != "1" && time[0] != "2"))
            time = "0" + time;

        while (time.length < 4)
            time += "0";

        var hours = parseInt(time.slice(0, 2));
        var minutes = parseInt(time.slice(2, 4));
        if ((hours > 24 || minutes > 59) || (hours == 24 && minutes > 0))
            return "00:00";

        time = time.slice(0, 2) + ":" + time.slice(2, 4);

        return time;
    }

    // Umwandlung eines Strings in Minuten seit Mitternacht, z.B. 06:30 -> 390
    toMinutesSinceMidnight(timeString) {
        if (timeString == "24:00")
            return 1440;
        else if (timeString === null || timeString === "" || timeString === undefined)
            return null;
        else {
            var hours = parseInt(timeString.slice(0, 2));
            var minutes = parseInt(timeString.slice(3, 5));
            return (hours * 60) + minutes;
        }
    }

    render() {
        return (
            <input ref={(r) => this._maskTextBoxRef = r} name={this.props.field.model} style={{ width: "100%" }} required={this.props.required} readOnly={this.props.disabled} data-label={this.props.field.name} />
        );
    }
}

export interface TimeTextBoxProps extends BaseComponentProps {
    field: TimeTextBoxField;
}

export interface MultipleCheckBoxesField extends BaseDataSourceField {
}

export interface TimeTextBoxField extends BaseField {
    modelForTimeString: string;
}